"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var preact_1 = require("preact");

var glamor_1 = require("glamor");

var glamor_tachyons_1 = require("glamor-tachyons");

var Tabs =
/*#__PURE__*/
function (_preact_1$Component) {
  _inherits(Tabs, _preact_1$Component);

  function Tabs() {
    _classCallCheck(this, Tabs);

    return _possibleConstructorReturn(this, _getPrototypeOf(Tabs).apply(this, arguments));
  }

  _createClass(Tabs, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          tabNames = _this$props.tabNames,
          activeTab = _this$props.activeTab,
          handleClick = _this$props.handleClick;
      var tabs = tabNames.length > 0 ? tabNames.map(function (name) {
        return preact_1.h(Tab, {
          key: name,
          id: name,
          handleClick: handleClick,
          isActive: name === activeTab
        }, name);
      }) : null;
      var tabStyle = glamor_1.css(Object.assign({
        overflowX: 'scroll',
        overflowY: 'hidden',
        whiteSpace: 'nowrap'
      }, glamor_tachyons_1.tachyons('bb b--light-gray pb3 mt3')));
      return preact_1.h("div", {
        className: "".concat(tabStyle, " visor-tabs")
      }, tabs);
    }
  }]);

  return Tabs;
}(preact_1.Component);

exports.Tabs = Tabs;

var Tab =
/*#__PURE__*/
function (_preact_1$Component2) {
  _inherits(Tab, _preact_1$Component2);

  function Tab() {
    _classCallCheck(this, Tab);

    return _possibleConstructorReturn(this, _getPrototypeOf(Tab).apply(this, arguments));
  }

  _createClass(Tab, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          isActive = _this$props2.isActive,
          handleClick = _this$props2.handleClick,
          id = _this$props2.id;
      var tabStyle = glamor_1.css(Object.assign({
        borderBottomColor: isActive ? '#357EDD' : '#AAAAAA',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        cursor: 'pointer',
        ':hover': {
          color: '#357EDD'
        },
        display: 'inline-block'
      }, glamor_tachyons_1.tachyons('b f5 mr3 pa2')));
      return preact_1.h("a", {
        className: "".concat(tabStyle, " tf-tab"),
        "data-isactive": isActive,
        onClick: function onClick() {
          return handleClick(id);
        }
      }, children);
    }
  }]);

  return Tab;
}(preact_1.Component);